import StepContainer from 'components/Project/Project/Step/StepContainer'
import FooterContainer from 'components/shared/Footer/FooterContainer'
import Loader from 'components/shared/Loader/Loader'
import PropTypes from 'prop-types'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

import './Project.css'
import SidebarContainer from './Sidebar/SidebarContainer'
import PrintoutImagesPreloader from 'components/Project/Printout/ImagesPreloader'
import Printout from 'components/Project/Printout/Printout'
import { useParams } from "react-router"
import { NoPrint } from 'components/shared/NoPrint/NoPrint'

const Project = ({ locale, project, progressCallback }) => {
  const userID = uuidv4()
  let params = useParams()
  const stepsOrLoader = () => {
    if (project.steps) {
      return (
        <div>
          <SidebarContainer locale={locale} project={project} />
          <StepContainer progressCallback={progressCallback} />
        </div>
      )
    }
    return <Loader delay={200} />
  }

  return (
    <React.Fragment>
      <NoPrint>
      <main className="c-project__layout u-clearfix" id="c-project__layout">
        {stepsOrLoader()}
      </main>
      <FooterContainer text="project.footer.feedback.text" userID={userID} />
      </NoPrint>
      <PrintoutImagesPreloader />
      <Printout locale={locale} project={project} slug={params.slug} />
    </React.Fragment>
  )
}

Project.propTypes = {
  locale: PropTypes.string.isRequired,
  project: PropTypes.object.isRequired,
  progressCallback: PropTypes.func.isRequired,
}

export default Project
